import { Component, OnInit } from '@angular/core';

// Services
import { AuthService } from '@app/services/auth.service';

@Component({
    selector: 'app-all-trips-driving-log-page',
    templateUrl: './all-trips.component.html',
    styleUrls: ['./all-trips.component.scss']
})

export class AllTripsDrivingLogComponent implements OnInit {
    public employeeId: number;

    constructor(private authService: AuthService) { }

    ngOnInit(): void {
        this.employeeId = this.authService.getEmployeeId();
    }
}
